import React, { Fragment, useState, useEffect, useContext } from 'react'
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom'

import AppContext from '../../../contexts/AppContext'
import Breadcrumbs from '../../Breadcrumbs'
import Header from '../../Header'
import Footer from '../../Footer'
import { breadcrumbsBy } from '../../../services/locations'
import useToastContext from '../../../hooks/useToastContext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner, faPhone, faPen, faTrash, faArrowLeft, faAt } from '@fortawesome/free-solid-svg-icons'
import { faCopy } from '@fortawesome/free-regular-svg-icons'
import { Helmet } from "react-helmet-async";
import { Modal } from '../../UI'
import moment from 'moment'

const capitalize = s => { if (typeof s !== 'string') return ''; return s.charAt(0).toUpperCase() + s.slice(1) }

const ArrowStep = ({ color1, color2, strokeColor }) => {
    if(!color1) color1 = '#eeeeee'
    if(!color2) color2 = '#eeeeee'
    if(!strokeColor) strokeColor = '#ffffff'
    return (
        <svg className="arrow" viewBox="0 0 150 500" xmlns="http://www.w3.org/2000/svg">
            <rect
                x="0" y="0" width="150" height="500"
                style={{ fill: color2 }}
            />
            <polyline style={{
                fill: color1,
                stroke: strokeColor,
                strokeWidth: 10
            }} points="0 0 150 250 0 500"/>
        </svg>
    )
}

const StatusProgress = ({ lead }) => {
    const primaryColor = 'rgb(52, 144, 220)'
    return (
        <div className="card mb-3">
            <div className="card-body overflow-hidden">
                <h4 className="card-title">Status progress</h4>

                <div className={'steps-wisard d-flex flex-row flex-wrap'}>
                    <div className={'item bg-primary text-white'}>
                        <span>New</span>
                        <ArrowStep
                            color1={primaryColor}
                            color2={!['new'].includes(lead.status) ? primaryColor : null}
                        />
                    </div>
                    <div className={'item' + ([ 'new' ].includes(lead.status) ? '' : ' bg-primary text-white')}>
                        <span>Contacted</span>
                        <ArrowStep
                            color1={['contacted', 'working', 'qualified', 'unqualified'].includes(lead.status) ? primaryColor : null}
                            color2={['working', 'qualified', 'unqualified'].includes(lead.status) ? primaryColor : null}
                        />
                    </div>
                    <div className={'item' + (['working', 'qualified', 'unqualified'].includes(lead.status) ? ' bg-primary text-white' : '')}>
                        <span>Working</span>
                        <ArrowStep
                            color1={['working', 'qualified', 'unqualified'].includes(lead.status) ? primaryColor : null}
                            color2={['qualified', 'unqualified'].includes(lead.status) ? primaryColor : null}
                        />
                    </div>
                    <div className={'item' + ([ 'qualified', 'unqualified' ].includes(lead.status) ? ' bg-primary text-white' : '')}>
                        <span>Qualified</span>
                        <ArrowStep
                            color1={['qualified', 'unqualified'].includes(lead.status) ? primaryColor : null}
                            color2={['unqualified'].includes(lead.status) ? primaryColor : null}
                        />
                    </div>
                    <div className={'item' + ([ 'unqualified' ].includes(lead.status) ? ' bg-primary text-white' : '')}>
                        <span>Unqualified</span>
                        {[ 'unqualified' ].includes(lead.status) && <ArrowStep color1={primaryColor} />}
                    </div>
                </div>


            </div>
        </div>
    )
}

const LeadEvent = ({ event }) => {
    let description = null
    if(event.type == 'created') description = 'Lead created'
    if(event.type == 'lead-step') description = 'Lead event'
    if(event.type == 'status-change') description = 'Lead status changed to "' + event.meta.status + '"'
    return (
        <div className="my-2">
            <small>{description} at {moment(event.created_at).format('MM/DD/YYYY hh:mm a')}</small>
            {event.comments && event.comments.map(comment =>
                <div className="card bg-light px-3 py-2 mt-2" key={comment.id}>
                    {comment.message}
                </div>
            )}
        </div>
    )
}

const LogACall = ({ lead, onCancel, onUpdated }) => {

    const { data, leadServices } = useContext(AppContext)

    const [ loading, setLoading ] = useState(false)

    const { register, handleSubmit, watch, errors, setError, reset } = useForm({
        defaultValues: {
            status: lead.status
        }
    });

    const addToast = useToastContext()

    const errorMessages = data => {
        if(data){
            if(data.message) addToast({title: 'Error', message: data.message, type: 'danger'})
            if(data.errors){
                const keys = Object.keys(data.errors)
                for(var i = 0; i < keys.length; i ++){
                    setError(keys[i], { type: "manual", message: data.errors[keys[i]].join('. ')})
                }
            }
        }
    }

    const onSubmit = data => {
        setLoading(true)
        leadServices.step(lead.id, data).then(res => {
            setLoading(false)
            addToast({title: 'Success', message: 'Lead successfully updated', type: 'success'})
            reset()
            if(typeof onUpdated == 'function') onUpdated(res)
        }).catch(res => {
            setLoading(false)
            errorMessages(res.data)
        })
    }

    return (
        <form className="" onSubmit={handleSubmit(onSubmit)}>

            <div className="mb-3">
                <label htmlFor="leadStatusId" className="lbl-sm">Change lead status to:</label>
                <select
                    id="leadStatusId"
                    className="custom-select custom-select"
                    defaultValue=""
                    name="status"
                    ref={register}
                >
                    <option value="">--None--</option>
                    <option value="contacted">Contacted</option>
                    <option value="working">Working</option>
                    <option value="qualified">Qualified</option>
                    <option value="unqualified">Unqualified</option>
                </select>
                {errors.type && <div className="invalid-feedback d-block">{errors.type.message}</div>}
            </div>

            <div className="mb-2">
                {lead.status == 'new' && <label className="lbl-sm">Log a call</label>}
                {['contacted', 'working', 'qualified', 'unqualified', 'complited'].includes(lead.status) && <label className="lbl-sm">Add a note</label>}
                <textarea name="message" rows="5" className="form-control mb-2" ref={register}></textarea>
                {errors.message && <div className="invalid-feedback d-block">{errors.message.message}</div>}
            </div>

            <div className="text-right">
                <button
                    type="button"
                    className="btn btn-light border"
                    onClick={() => {
                        if(typeof onCancel == 'function') onCancel()
                    }}
                >Cancel</button>
                <button type="submit" className="btn btn-primary ms-2">Submit</button>
            </div>
        </form>
    )
}

const NextAction = ({ lead, onUpdated }) => {

    const { data, leadServices } = useContext(AppContext)
    const { app, isReady } = data
    const { user } = app

    const addToast = useToastContext()

    const [ actionState, setActionState ] = useState(null)

    const salutation = lead && lead.salutation ? (capitalize(lead.salutation) + '. ') : ''
    const contact = salutation + (lead && lead.name)

    const copyToClipBoard = e => {
        e.preventDefault()
        var textField = document.createElement('textarea')
        textField.innerText = lead.promo_url
        document.body.appendChild(textField)
        textField.select()
        textField.setSelectionRange(0, 99999)
        document.execCommand('copy')
        textField.remove()
        addToast({message: 'Link copied to clipboard', type: 'success'})
    }

    return (
        <Fragment>
            <div className="d-flex justify-content-between flex-wrap">
                <div>
                    <h3>
                        {lead.phone && <span><FontAwesomeIcon icon={faPhone} className="text-muted" /> {lead.phone}{' - '}</span>}
                        {contact}
                    </h3>
                    {lead.email &&
                        <p className="lead">
                            <FontAwesomeIcon icon={faAt} className="text-muted me-2" />
                            <a href={'mailto:' + lead.email + '?subject=' + process.env.MIX_APP_NAME + ' free classified ads and lots more!&body=Use this promo link to get free credits to your account for your premium ad listings ' + lead.promo_url}>{lead.email}</a>
                        </p>
                    }
                    <p>
                        Promo link for this lead: <a href="" onClick={copyToClipBoard}>{lead.promo_url} <FontAwesomeIcon icon={faCopy} /></a>
                    </p>
                    <p className="m-5">
                        <a href={`/api/lead/${lead.id}/qr-code`} target="_blank"><img src={`/api/lead/${lead.id}/qr-code`} alt="" /></a>
                    </p>
                </div>
                <div>
                    {lead.status == 'new' ? (
                        <button
                            className={'btn btn-' + (actionState == 'log-a-call' ? 'light border' : 'primary')}
                            onClick={() => setActionState(actionState == 'log-a-call' ? null : 'log-a-call')}
                        >Log a call</button>
                    ) : (
                        <button
                            className={'btn btn-' + (actionState == 'add-a-note' ? 'light border' : 'primary')}
                            onClick={() => setActionState(actionState == 'add-a-note' ? null : 'add-a-note')}
                        ><span className="text-nowrap">Change status / </span><span className="text-nowrap">add a note</span></button>
                    )}
                </div>
            </div>
            {['log-a-call', 'add-a-note'].includes(actionState) &&
                <LogACall
                    lead={lead}
                    onCancel={() => {
                        setActionState(null)
                    }}
                    onUpdated={() => {
                        onUpdated()
                        setActionState(null)
                    }}
                />
            }
        </Fragment>
    )
}

const View = ({ match, history }) => {

    const { data, leadServices, location } = useContext(AppContext)
    const { app, isReady } = data
    const { user } = app

    const [ loading, setLoading ] = useState(false)
    const [ deleting, setDeleting ] = useState(false)
    const [ lead, setLead ] = useState(null)

    const id = parseInt(match.params.id)

    const [ showDialog, setShowDialog ] = useState(false)
    const [ dialogOptions, setDialogOptions ] = useState({})

    const modalDialog = (options) => {
        return new Promise((resolve, reject) => {
            options.onButtonClick = button => {
                if(['cancel', 'close'].includes(button)){
                    setShowDialog(false)
                    reject()
                }
                if(['delete'].includes(button)){
                    setShowDialog(false)
                    resolve()
                }
            }
            options.show = showDialog
            setDialogOptions(options)
            setShowDialog(true)
        })
    }

    const loadLead = () => {
        return new Promise((resolve, reject) => {
            setLoading(true)
            leadServices.view(id).then(res => {
                setLead(res.lead)
                setLoading(false)
                resolve()
            }).catch(res => {
                if(res.status == 404) history.push("/page-not-found")
                if(res.status == 500) history.push("/server-error")
                reject()
            })
        })
    }

    const deleteLead = () => {
        return new Promise((resolve, reject) => {
            setDeleting(true)
            leadServices.delete(id).then(res => {
                setDeleting(false)
                history.push("/account/leads")
            }).catch(res => {
                if(res.status == 404) history.push("/page-not-found")
                if(res.status == 500) history.push("/server-error")
                reject()
            })
        })
    }

    useEffect(() => {
        if(isReady) loadLead()
    }, [ isReady ])

    const title = lead ? ('Lead #' + lead.id) : "View a lead"
    const salutation = lead && lead.salutation ? (capitalize(lead.salutation) + '. ') : ''
    const contact = salutation + (lead && lead.name)

    return (
        <Fragment>
            <div>
                <Header history={history} />
                <main className="py-4">
                    <div className="container">
                        <Breadcrumbs list={breadcrumbsBy(location, [{url: '/account', title: 'Dashboard'}, {url: '/account/leads', title: 'Leads & sales'}, {title}])} />
                        <Helmet><title>{title + ' | ' + process.env.MIX_APP_NAME}</title></Helmet>
                        <div className="d-flex justify-content-between">
                            <h1 className="mt-0">{title}</h1>
                            <div className="ms-3">
                                <Link tag="a" to={'/account/leads'} className="btn btn-outline-secondary">
                                    <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
                                    Back to Leads
                                </Link>
                                {lead &&
                                    <Fragment>
                                        <Link tag="a" to={'/account/leads/edit/' + lead.id} className="btn btn-outline-primary ms-2">
                                            <FontAwesomeIcon icon={faPen} className="me-2" />
                                            Edit
                                        </Link>
                                        <button className="btn btn-outline-danger ms-2"onClick={() => {
                                            modalDialog({
                                                title: 'Confirm',
                                                description: 'Are you sure want to delete the lead #' + lead.id + '?',
                                                buttons: ['cancel', 'delete'],
                                                size: 'md'
                                            }).then(() => deleteLead()).catch(res => {})
                                        }}>
                                            {!deleting && <FontAwesomeIcon icon={faTrash} className="me-2" />}
                                            {deleting && <FontAwesomeIcon icon={faSpinner} spin className="me-2" />}
                                            Delete
                                        </button>
                                    </Fragment>
                                }
                            </div>
                        </div>

                        {lead &&
                            <Fragment>
                                <StatusProgress lead={lead} />

                                <div className="row d-flex">
                                    <div className="col-lg-5 mb-3">

                                        <div className="card h-100">
                                            <div className="card-body">
                                                <div className="d-flex justify-content-between">
                                                    <h4 className="card-title">Lead details</h4>
                                                    <Link tag="a" to={'/account/leads/edit/' + lead.id} className="ms-2">
                                                        <FontAwesomeIcon icon={faPen} className="me-2" />
                                                        Edit
                                                    </Link>
                                                </div>
                                                
                                                <table className="table table-sm mb-0">
                                                    <tbody>
                                                        <tr>
                                                            <th className="text-right text-nowrap">Lead ID</th>
                                                            <td className="">{lead.id}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className="text-right text-nowrap">Lead type</th>
                                                            <td className="">{capitalize(lead.type)}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className="text-right text-nowrap">Phone</th>
                                                            <td className="">{lead.phone}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className="text-right text-nowrap">Contact</th>
                                                            <td className="">{contact}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className="text-right text-nowrap">Email</th>
                                                            <td className="">{lead.email}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className="text-right text-nowrap">Company</th>
                                                            <td className="">{lead.company}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className="text-right text-nowrap">Title</th>
                                                            <td className="">{lead.title}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className="text-right text-nowrap">Address</th>
                                                            <td className="">{lead.address}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className="text-right text-nowrap">Website</th>
                                                            <td className="">{lead.website}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className="text-right text-nowrap">Rating</th>
                                                            <td className="">{capitalize(lead.rating)}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className="text-right text-nowrap">Lead source</th>
                                                            <td className="">{capitalize(lead.source)}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className="text-right text-nowrap">Industry</th>
                                                            <td className="">{capitalize(lead.industry)}</td>
                                                        </tr>
                                                        {lead.description ? (
                                                            <tr>
                                                                <th className="text-right text-nowrap">Description</th>
                                                                <td className="">{lead.description}</td>
                                                            </tr>
                                                        ) : null}
                                                    </tbody>
                                                </table>

                                                {lead && lead.affiliate &&
                                                    <div>
                                                        <h4 className="card-title mt-3">User signed-up</h4>
                                                        <table className="table table-sm mb-0">
                                                            <tbody>
                                                                <tr>
                                                                    <th className="text-right text-nowrap">User ID</th>
                                                                    <td className="">...{lead.affiliate.str_id.substr(-4)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th className="text-right text-nowrap">User name</th>
                                                                    <td className="">{lead.affiliate.full_name}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th className="text-right text-nowrap">User email</th>
                                                                    <td className="">{lead.affiliate.email}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th className="text-right text-nowrap">Active</th>
                                                                    <td className="">{lead.affiliate.active ? 'Yes' : 'No'}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th className="text-right text-nowrap">Posts count</th>
                                                                    <td className="">{lead.affiliate.posts_count}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                }

                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-lg-7">

                                        <div className="card h-100">
                                            <div className="card-body">
                                                <h4 className="card-title">Lead activity</h4>
                                                <NextAction lead={lead} onUpdated={loadLead} />
                                                <hr />
                                                {lead.events.map((event, index) =>
                                                    <Fragment key={event.id}>
                                                        {index > 0 && <hr />}
                                                        <LeadEvent event={event} />
                                                    </Fragment>
                                                )}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </Fragment>
                        }
                    </div>
                </main>
                <Modal {...dialogOptions} show={showDialog} />
            </div>
            <Footer />
        </Fragment>
    )
}

export default View
